import { Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { IInvoicePreviewItem } from '@/shared/api/billing/types';
import { useInterfaceLanguage } from '@/shared/i18n';

type InvoiceLineItemProps = {
  formatPrice: (amount: number, currency: string) => string;
  item: IInvoicePreviewItem;
  showRemoveLabel?: boolean;
};

const isPromoCodeLine = (description: string) => {
  return description.toLowerCase().includes('promo') || description.toLowerCase().includes('coupon');
};

export const InvoiceLineItem = ({ formatPrice, item, showRemoveLabel = false }: InvoiceLineItemProps) => {
  const { t } = useInterfaceLanguage();
  const hasDiscount = item.discount_amount && item.discount_amount !== item.final_amount;
  const isPromo = isPromoCodeLine(item.description);
  const textColor = isPromo ? 'primary.700' : 'grey.700';

  return (
    <Stack alignItems="center" direction="row" justifyContent="space-between">
      <Typography color={textColor} sx={{ maxWidth: '85%' }} variant="body-2">
        {item.description} {showRemoveLabel && item.amount === 0 ? t('billing.confirm.remove') : ''}
      </Typography>
      <Stack alignItems="center" direction="row" gap={4}>
        {hasDiscount ? (
          <Typography
            sx={{
              textDecoration: 'line-through',
            }}
            color="grey.300"
            variant="body-2"
          >
            {formatPrice(item.discount_amount, item.currency)}
          </Typography>
        ) : null}
        <Typography color={textColor} variant="body-2">
          {formatPrice(item.final_amount, item.currency)}
        </Typography>
      </Stack>
    </Stack>
  );
};
